import {
  detachLayoutProps,
  WSMarginProps,
  WSSelect
} from "@wingspanhq/fe-component-library";
import { useQueryEngagementsListAll } from "../../../../query/engagements/queries/useQueryEngagementsListAll";
import { useQueryUserProfile } from "../../../../query/users/queries";
import { useUserId } from "../../../../query/hooks/helpers";

export const defaultCollaboratorGroupOption = {
  label: "Do not add contractors to group",
  value: "NONE"
};

type Props = WSMarginProps & {
  selectedEngagementId: string;
  onSelectEngagement: (option: { label: string; value: string } | null) => void;
};
export const SelectEngagementField: React.FC<Props> = ({
  selectedEngagementId,
  onSelectEngagement,

  ...otherProps
}) => {
  const { layoutProps } = detachLayoutProps(otherProps);

  const userId = useUserId();
  const queryUser = useQueryUserProfile(userId);
  const queryEngagements = useQueryEngagementsListAll({
    filter: {
      isDefault: false
    }
  });

  const engagements = queryEngagements.data || [];
  const user = queryUser.data!;

  const engagementOptions = engagements
    .map(engagement => ({
      label: engagement.name,
      value: engagement.engagementId
    }))
    .filter(option => option.label && option.value); // filter out empty values

  const handleSelectEngagement = (value: any) => {
    const engagement = engagementOptions.find(e => e.value === value);
    onSelectEngagement(engagement ?? null);
  };

  const showEngagementField = engagementOptions.length > 0;

  if (showEngagementField) {
    return (
      <WSSelect
        {...layoutProps}
        label="Engagement (optional)"
        value={selectedEngagementId}
        onChange={handleSelectEngagement}
        tooltip={{
          dark: true,
          title: "Engagement (optional)",
          children: `An engagement is a type of work arrangement that allows payers to organize their diverse work relationships in a flexible way. One engagement can be assigned when adding a new contractor. Other engagements can be added later.
            
    If you have not set up engagements or do not plan to use engagements, you can skip this field. Engagements can be updated in the Contractors section of the app at any time.`
        }}
        options={engagementOptions}
        internalSearch
        placeholder="Select an option"
      />
    );
  }

  return null;
};
